//"use client"
import { styled } from "@phntms/css-components";
import {SocialLinks} from "@itchannelplus/ui/components/SocialLinks";
import styles from "./styles.module.scss";
import { motion } from "framer-motion";

export const MenuContainer = styled('div', {
  css: styles.menuContainer,
  variants: {
    isOpened: {
      true: styles.opened
    }
  }
})

export const MenuBottom = styled('div', {
  css: styles.menuBottom,
  variants: {

  }
})

export const LinkWrapper = styled('div', {
  css: styles.linkWrapper,
  variants: {

  }
})

export const Logos = styled('div', {
  css: styles.logos,
  variants: {

  }
})

export const StyledSocialLinks = styled(SocialLinks, {
  css: styles.socialLinks,
  variants: {

  }
})



export const MenuContent = styled('div', {
  css: styles.menuContent,
  variants: {
    isOpened: {
      true: styles.opened
    }
  }
})

export const Content = styled(motion.div, {
  css: styles.content,
  variants: {

  }
})

export const Breadcrumb = styled('div', {
  css: styles.breadcrumb,
  variants: {

  }
})

export const MenuItem = styled('div', {
  css: styles.menuItem,
  variants: {

  }
})

export const MenuLabel = styled('span', {
  css: styles.menuLabel,
  variants: {
    small: {
      true: styles.small,
    }
  }
})

export const BgLogo = styled('div', {
  css: [styles.bgLogo, 'background-lv', 'light'],
  variants: {

  }
})
